import React, { useState } from "react";
import "./CustomTooltipBottom.scss";

export function CustomTooltipBottom({
  trigger,
  boldText,
  normalText,
  minWidth = "340px",
  maxWidth = "450px",
  minHeight = "66px",
  maxHeight,
}) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="custom-tooltip-bottom-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <div className="custom-tooltip-bottom-trigger">{trigger}</div>
      {isVisible && (
        <div
          className="custom-tooltip-bottom-popup"
          style={{ minWidth, maxWidth, minHeight }}
        >
          <div className="custom-tooltip-bottom-arrow"></div>
          <div className="custom-tooltip-bottom-content">
            <div className="custom-tooltip-bottom-bold">{boldText}</div>
            <div className="custom-tooltip-bottom-normal">{normalText}</div>
          </div>
        </div>
      )}
    </div>
  );
}
